import { OnInit } from '@angular/core';
import * as moment from 'moment';

import {
  PageBase,
  FormModeEnum,
  ToolbarItem,
  FieldStructure,
  ToolbarAction,
  TableSettings,
  TableModeEnum,
  TableActionEnum,
  TableActionParams,
  FilterSettings,
  TableActionFilterParams,
  BackendService,
  UtilService,
  ModalService,
  NotificationService,
  TableComponent,
} from 'beyond-util';
import { ActionType } from '../../../enums/action-type.enum';
declare var $: any;

export class SifarnikBase extends PageBase implements OnInit {
  public static readonly DATE_TYPE: string = 'date';
  public mode: FormModeEnum;

  protected FormModeEnum = FormModeEnum;
  protected TableModeEnum = TableModeEnum;

  protected fieldStructure: FieldStructure;
  protected settingsTable: TableSettings;
  protected settingsFilter: FilterSettings;
  protected settingsTableDetails: TableSettings;

  protected orderList: any[];
  protected orderListDetails: any[];
  protected orderListCount: any;

  protected _lastUsedFilter: TableActionFilterParams;
  protected _orderBeforeEditing: any;

  protected filterQuery = '';
  protected _dataCount: number;

  protected actionType: ActionType;

  private _order: any;

  public currentPage: number;

  get order(): any {
    return this._order;
  }

  set order(value: any) {
    this._order = value;
    this.changeName();
    this.infobarDocument = value;
  }

  get isModeTable(): boolean {
    return this.mode === FormModeEnum.Table;
  }

  get isModeAdd(): boolean {
    return this.mode === FormModeEnum.Add;
  }

  get isModeEdit(): boolean {
    return this.mode === FormModeEnum.Edit;
  }

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService
  ) {
    super(_backendService);
  }

  ngOnInit() {
    this.filterQuery = '?pageNumber=1&pageSize=25';
    this.changeMode(FormModeEnum.Table);
    this.firstTableLoad();
    this.loadSettings();
  }

  loadSettings() {}

  setSettings(allSettings: any) {
    this.settingsTable = new TableSettings(allSettings, 'table');
    this.settingsFilter = new FilterSettings(allSettings);
  }

  changeMode(mode: FormModeEnum) {
    this.mode = mode;
    this.changeName();

    switch (this.mode) {
      case FormModeEnum.Table:
        this.onTableMode();
        break;

      case FormModeEnum.Edit:
        this.onEditMode();
        break;

      case FormModeEnum.View:
        this.onViewMode();
        break;

      case FormModeEnum.Add:
        this.onAddMode();
        break;
    }
  }

  onTableMode() {
    this.setToolbarOptions({
      toolbarVisible: false,
    });

    if (this.infobarVisible) {
      this.infobarVisible = false;
    }
  }

  onEditMode() {
    this._orderBeforeEditing = { ...this.order };
    this.setToolbarOptions({
      items: [ToolbarItem.ItemSave(), ToolbarItem.ItemCancel()],
    });
  }

  onViewMode() {
    // Moved when order loads
    if (typeof this.order === 'undefined') {
      this.setToolbarOptions({
        items: [],
      });
    } else {
      let leftEnabled = true;
      let rightEnabled = true;

      this.orderList.forEach((order, index) => {
        if (order.id === this.order.id) {
          if (this.shouldDisableLeft(index)) {
            leftEnabled = false;
          }
          if (this.shouldDisableRight(index)) {
            rightEnabled = false;
          }
        }
      });

      this.setToolbarOptions(
        {
          items: this.getViewModeToolbarItems(),
        },
        {
          leftEnabled,
          rightEnabled,
        }
      );
    }
  }

  isNotNumber(value: any) {
    return isNaN(value) || !Number.isInteger(+value);
  }

  isNotNumeric(value: any) {
    return isNaN(value);
  }

  onViewModeWithParams(
    itemAdd: boolean,
    itemDelete: boolean,
    itemEdit: boolean
  ) {
    // Moved when order loads
    if (typeof this.order === 'undefined') {
      this.setToolbarOptions({
        items: [],
      });
    } else {
      let leftEnabled = true;
      let rightEnabled = true;

      this.orderList.forEach((order, index) => {
        if (order.id === this.order.id) {
          if (this.shouldDisableLeft(index)) {
            leftEnabled = false;
          }
          if (this.shouldDisableRight(index)) {
            rightEnabled = false;
          }
        }
      });

      this.setToolbarOptions(
        {
          items: this.getViewModeToolbarItemsWithParams(
            itemAdd,
            itemDelete,
            itemEdit
          ),
        },
        {
          leftEnabled,
          rightEnabled,
        }
      );
    }
  }

  getViewModeToolbarItems() {
    return [
      // ToolbarItem.ItemAdd(true, true, null, 'Dodaj'),
      // ToolbarItem.ItemDelete(),
      // ToolbarItem.ItemEdit(true, true, null, 'Izmeni'),
    ];
  }

  getViewModeToolbarItemsWithParams(
    itemAdd: boolean,
    itemDelete: boolean,
    itemEdit: boolean
  ) {
    const toolbarItems: ToolbarItem[] = [];

    if (itemAdd) {
      toolbarItems.push(ToolbarItem.ItemAdd(true, true, null, 'Dodaj'));
    }
    if (itemDelete) {
      toolbarItems.push(ToolbarItem.ItemDelete());
    }
    if (itemEdit) {
      toolbarItems.push(ToolbarItem.ItemEdit(true, true, null, 'Izmeni'));
    }

    return toolbarItems;
  }

  shouldDisableLeft(index: number) {
    return this._lastUsedFilter.pageCurrent === 1 && index === 0;
  }

  shouldDisableRight(index: number) {
    return (
      (this._lastUsedFilter.pageCurrent - 1) * this._lastUsedFilter.rowsOnPage +
        index +
        1 ===
      this.orderListCount
    );
  }

  onAddMode() {
    this.setToolbarOptions({
      items: [ToolbarItem.ItemSave()],
    });
  }

  changeName() {}

  onToolbarAction(event: ToolbarAction) {
    switch (event) {
      case ToolbarAction.Close:
        this.onClose();
        break;

      case ToolbarAction.Delete:
        this.onDelete(null, this.onDeleteConfirm.bind(this));
        break;

      case ToolbarAction.Save:
        this.onSave();
        break;

      case ToolbarAction.Cancel:
        this.onCancel();
        break;

      case ToolbarAction.Aneksiraj:
        this.onAneksMode();
        break;

      case ToolbarAction.Podugovor:
        this.onAddPodugovor();
        break;

      case ToolbarAction.Edit:
        this.onEdit();
        break;

      case ToolbarAction.Add:
        this.order = {};
        this.onTableActionAdd();
        break;

      case ToolbarAction.PreuzmiIzSapa:
        this.onPreuzmiIzSAPa();
        break;

      case ToolbarAction.ProveriVideoServer:
        this.checkVS();
        break;

      case ToolbarAction.PogledajSpot:
        this.pogledajSpot();
        break;
    }
  }

  checkVS() {}

  pogledajSpot() {}

  onPreuzmiIzSAPa() {}

  onAddPodugovor() {}

  onViewPodugovor(podugovor: any) {
    this.infobarPodugovor = podugovor;
  }

  protected onEdit() {
    this.changeMode(FormModeEnum.Edit);
  }

  onAneksMode() {}

  onClose() {
    this.loadSettings();
    this.order = {};
    this.changeMode(FormModeEnum.Table);
  }

  onSave() {
    this.isModeAdd ? this.addOrder() : this.updateOrder();
  }

  mapStringToNumber(collection: any[], property: string, document: any) {
    const num = +document[property];
    collection.find(f => f.rbr === document.rbr)[property] =
      // tslint:disable-next-line: triple-equals
      isNaN(num) ? 0 : num;
  }

  copyProperties(source: any, dest: any) {
    if (!dest) {
      dest = { ...source };

      return;
    }

    for (const key in source) {
      if (dest.hasOwnProperty(key)) {
        dest[key] = source[key];
      }
    }
  }

  deepCopyFunction(inObject) {
    let outObject, value, key;

    if (typeof inObject !== 'object' || inObject === null) {
      return inObject; // Return the value if inObject is not an object
    }

    // Create an array or object to hold the values
    outObject = Array.isArray(inObject) ? [] : {};

    // tslint:disable-next-line: forin
    for (key in inObject) {
      value = inObject[key];
      outObject[key] = this.deepCopyFunction(value);
    }

    return outObject;
  }

  onCancel() {
    this.copyProperties(this._orderBeforeEditing, this.order);
    this.changeMode(FormModeEnum.View);
  }

  listTableAction(event: TableActionParams, isFilter: boolean) {
    switch (event.action) {
      case TableActionEnum.Select:
        this.onSelect(event);
        break;

      case TableActionEnum.Filter:
        event.isFilterEvent = isFilter;
        this.onTableActionFilter(event);
        break;

      case TableActionEnum.Edit:
        this._orderBeforeEditing = { ...this.order };
        break;

      case TableActionEnum.EditCancel:
        this.copyProperties(this._orderBeforeEditing, this.order);
        break;

      case TableActionEnum.View:
        this.onTableActionView();
        break;

      case TableActionEnum.Update:
        this.onTableActionUpdate(event);
        break;

      case TableActionEnum.Add:
        this.order = {};
        this.onTableActionAdd();
        break;

      case TableActionEnum.Delete:
        this.onDelete(null, this.onDeleteConfirm.bind(this));
        break;

      case TableActionEnum.Save:
        this.onTableInlineSave(event);
        break;

      case TableActionEnum.AddCancel:
        this.onInlineAddCancel(this.order);
        break;
    }
  }

  onSelect(event: TableActionParams) {
    this.order = event.document;
  }

  tableDetailsAction(event: TableActionParams) {
    switch (event.action) {
      case TableActionEnum.EditCancel:
        this.onDetailsEditCancel(event);
        break;

      case TableActionEnum.Select:
        this.onDetailsTableSelect(event.document);
        break;

      case TableActionEnum.Save:
        this.onDetailsTableSave(event);
        break;

      case TableActionEnum.Update:
        this.onDetailsTableUpdate(event);
        break;

      case TableActionEnum.Delete:
        this.onDetailsActionDelete(event);
        break;

      case TableActionEnum.Edit:
        this.onDetailsTableEdit(event.document);
        break;

      case TableActionEnum.Add:
        this.onDetailsTableActionAdd(event);
        break;

      default:
    }
  }

  onDetailsEditCancel(event) {}

  onDetailsTableActionAdd(event) {}

  onDetailsActionDelete(event) {}

  onDetailsTableSave(event: TableActionParams) {}

  onTableInlineSave(event) {}

  onDetailsTableUpdate(event: TableActionParams) {}

  onDetailsTableEdit(document: any) {}

  onDetailsTableSelect(data: any) {}

  onTableActionAdd() {}

  onDelete(
    event,
    callback,
    message = 'Da li ste sigurni da želite da obrišete?'
  ) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this._modalService.openModal(message, response => {
      if (response) {
        callback();
      }
    });
  }

  onInlineAddCancel(order) {
    this.orderList.filter(o => o.rbr.toString() === order.rbr.toString());
  }

  onDeleteConfirm() {}

  onDetailsDeleteConfirm() {}

  addOrder() {}

  updateOrder() {}

  refreshTable() {}

  onTableActionView() {}

  validirano(isValid: boolean) {
    if (isValid) {
      switch (this.actionType) {
        case ActionType.Create:
          this.create();
          break;
        case ActionType.Update:
          this.update();
      }
    } else {
      this.notifyError('Niste uneli sva obavezna polja.');
    }
  }

  setActionType(action: ActionType) {
    this.actionType = action;
  }

  create() {}

  update() {}

  notifyError(message: string) {
    this._notificationService.notyError(message);
  }

  notify(message: string) {
    this._notificationService.openNoty(message);
  }

  // Metoda radi previse razlicitih stavri. Metodu treba svuda zameniti sa responseHasError, notifyErrorFromResponse i changeMode
  openServiceError(data) {
    if (data['Error'] && data['Error']['ErrorMessage']) {
      this.notifyError(data['Error']['ErrorMessage']);

      return true;
    } else {
      this.changeMode(FormModeEnum.Table);
    }
  }

  responseHasError(data: any): boolean {
    return data['Error'] && data['Error']['ErrorMessage'];
  }

  getResponseError(data: any): string {
    return data['Error']['ErrorMessage'];
  }

  notifyErrorFromResponse(data: any) {
    this.notifyError(this.getResponseError(data));
  }

  setRbr(listDetails: any[]) {
    if (listDetails && listDetails.length) {
      listDetails.forEach((x, index) => (x.rbr = index + 1));
    }

    return listDetails;
  }

  setId(listDetails: any[]) {
    if (listDetails && listDetails.length) {
      listDetails.forEach((x, index) => (x.id = index + 1));
    }
  }

  splitDetails(
    settings: any,
    firstColumnSize?: number,
    secColSmallerOrEqual: boolean = true
  ) {
    const allDetails = settings.formSettings.header[0].panels[0].controls[0];
    const newFirstCol = [];
    const newSecondCol = [];

    if (!firstColumnSize) {
      firstColumnSize = Math.ceil(allDetails.length / 2);
    } else if (firstColumnSize > allDetails.length) {
      console.log(
        'Setovan broj podataka po koloni je veći od ukupnog broja podataka!'
      );

      firstColumnSize = Math.ceil(allDetails.length / 2);
    }

    if (
      secColSmallerOrEqual &&
      allDetails.length - firstColumnSize > firstColumnSize
    ) {
      firstColumnSize = allDetails.length - firstColumnSize;
    }

    for (let i = 0; i < allDetails.length; i++) {
      if (i < firstColumnSize) {
        newFirstCol.push(allDetails[i]);
      } else {
        newSecondCol.push(allDetails[i]);
      }
    }

    settings.formSettings.header[0].panels[0].controls[0] = newFirstCol;
    settings.formSettings.header[0].panels[0].controls[1] = newSecondCol;
  }

  setInfobar(visible: boolean, korisnik: string = null, datumPromene: any) {
    if (korisnik) {
      this.infobarDocument.korisnik = korisnik;
    }

    if (datumPromene) {
      this.infobarDocument.datumPromene = datumPromene;
    }

    this.infobarVisible = visible;
  }

  disableInlineActions(settings: any) {
    settings.inlineAdding = false;
    settings.inlineEditing = false;
  }

  onTableActionUpdate(event: TableActionParams) {
    if (this.order.hasOwnProperty('Id') && this.order.hasOwnProperty('id')) {
      delete this.order['id'];
    }
  }

  onTableActionFilter(event: TableActionParams) {
    this.makeFilterQueryString(event);
    this.loadSettings();
  }

  makeFilterQueryString(event: TableActionParams) {
    this._lastUsedFilter.filterObjects = this.getFilterObjects(event);

    this._lastUsedFilter.pageCurrent = event.filter.pageCurrent
      ? event.filter.pageCurrent
      : this._lastUsedFilter.pageCurrent;

    this.setPageAfterFilter(event);

    this._lastUsedFilter.rowsOnPage = event.filter.rowsOnPage
      ? event.filter.rowsOnPage
      : this._lastUsedFilter.rowsOnPage;

    this._lastUsedFilter.sortOrder = event.filter.sortOrder
      ? event.filter.sortOrder
      : this._lastUsedFilter.sortOrder;

    this._lastUsedFilter.direction = event.filter.direction
      ? event.filter.direction
      : this._lastUsedFilter.direction;

    let query = this.getInitialQuery(event);
    query = this.getOrderQuery(event, query);
    query = this.getFilterQuery(query);

    this.filterQuery = query;
  }

  // Set current page on 1 when user uses filter button (when different data is requested)
  private setPageAfterFilter(event: TableActionParams) {
    if (event.isFilterEvent) {
      this.currentPage = 1;
    } else {
      this.currentPage = this._lastUsedFilter
        ? this._lastUsedFilter.pageCurrent
        : 1;
    }
  }

  getInitialQuery(event: TableActionParams) {
    const hasAmpersand =
      this.getValidFilters().length || this._lastUsedFilter.sortOrder
        ? '&'
        : '';

    if (!event.filter.hasOwnProperty('rowsOnPage')) {
      return `?pageNumber=1&pageSize=${this._lastUsedFilter.rowsOnPage}${hasAmpersand}`;
    }

    return `?pageNumber=${this._lastUsedFilter.pageCurrent}&pageSize=${this._lastUsedFilter.rowsOnPage}${hasAmpersand}`;
  }

  getOrderQuery(event: TableActionParams, query: string) {
    if (this._lastUsedFilter.sortOrder) {
      const direction = event.filter.direction
        ? event.filter.direction
        : this._lastUsedFilter.direction;

      return `${query}order=${
        this._lastUsedFilter.sortOrder.fieldName
      }&orderDirection=${direction}${
        this._lastUsedFilter.filterObjects.length ? '&' : ''
      }`;
    } else {
      return query;
    }
  }

  getFilterQuery(query: string) {
    this.getValidFilters().forEach((filter, i) => {
      query = `${query}${filter.name}=${this.getFilterValue(
        filter.type,
        filter.value
      )}${this.getValidFilters().length - 1 !== i ? '&' : ''}`;
    });

    return query;
  }

  getValidFilters() {
    return this._lastUsedFilter.filterObjects.filter(f =>
      this.hasFilterValue(f)
    );
  }

  hasFilterValue(filter) {
    return (
      filter.value === 0 || filter.value /*&& filter.value !== 'undefined'*/
    );
  }

  getFilterValue(type: string, value: string) {
    if (type === SifarnikBase.DATE_TYPE) {
      return moment(value).format('YYYY-MM-DD');
    }

    if (type === 'check') {
      return +value === 1;
    }

    return encodeURIComponent(value);
  }

  getFilterObjects(event: TableActionParams) {
    if (
      !event.filter.hasOwnProperty('sortOrder') &&
      !event.filter.filterObjects.length
    ) {
      return [];
    }

    return event.filter.filterObjects.length
      ? event.filter.filterObjects
      : this._lastUsedFilter.filterObjects;
  }

  subFilterPage() {
    if (this.orderList.length === 1) {
      const event = new TableActionParams();
      event.filter = new TableActionFilterParams();
      event.filter.filterObjects = [];

      this._lastUsedFilter.pageCurrent = this._lastUsedFilter.pageCurrent - 1;
      this.makeFilterQueryString(event);
    }
  }

  removeField(settings: any, name: string) {
    const allFieldsIndex = settings.allFields.findIndex(x => x.name === name);

    const id = settings.allFields.find(x => x.name === name).id;

    const detailsIndex = settings.formSettings.header[0].panels[0].controls[0].findIndex(
      x => x === id
    );

    settings.allFields.splice(allFieldsIndex, 1);
    settings.formSettings.header[0].panels[0].controls[0].splice(
      detailsIndex,
      1
    );
  }

  setAllFields(filterSettings?: FilterSettings) {
    const settings = filterSettings ? filterSettings : this.settingsFilter;

    settings.fieldList.forEach(field => {
      const filterWithItem = { ...field };
      filterWithItem.fieldMapItem = UtilService.getFieldMapItem(
        settings.relations,
        field
      );

      if (filterSettings && field['name'] === 'datum') {
        field.filterMapItems = [];
        field.filterMapItems.push(filterWithItem);
        field.filterMapItems.push({ ...filterWithItem });
      } else {
        field.filterMapItems = [filterWithItem];
      }
    });
  }

  firstTableLoad() {
    this._lastUsedFilter = {
      pageCurrent: 1,
      filterQuery: '',
      filterDate: '',
      filterObjects: [],
      filterCombined: null,
      rowsOnPage: 25,
      sortOrder: null,
      direction: '',
      relations: [],
    };
  }

  showRowError(
    event: any,
    message: string,
    contentPlaceholder: TableComponent
  ) {
    const selector = $(
      contentPlaceholder
        .getItemRef()
        .querySelector(`table tbody tr:nth-of-type(${event.index + 1})`)
    );

    selector.addClass('disabled');
    this._notificationService.notyError(message);
    setTimeout(() => {
      selector.removeClass('disabled');
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/sifarnik-base/sifarnik-base.ts